import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Exam Related Information</h1>
                <p>Home &gt;  Exam Related Information</p>
            </div>
        </div>
    )
}

export default Hero;